// ketoneCapture.js — Keto Scan breath-meter OCR via Gemini Vision.
//
// analyseKetonePhoto(imageDataUrl):
//   High / medium confidence → auto-commits to ketoneLog, returns { committed, entry }
//   Low confidence           → returns { needsConfirm, rawValue, rawUnit }
//   Error                    → throws

import { callGeminiVision } from "../geminiAI";
import { MODELS } from "./aiConfig";
import { addKetoneReading } from "./ketoneLog";

const KETONE_SCHEMA = {
  type: "object",
  properties: {
    value:      { type: "number" },
    unit:       { type: "string", enum: ["mmol/L", "ACE", "unknown"] },
    confidence: { type: "string", enum: ["high", "medium", "low"] },
  },
  required: ["value", "unit", "confidence"],
};

const SYS = `You are reading a Keto Scan breath ketone meter display. Return only the numeric reading shown. If you can't read it clearly, return confidence: low.`;

export async function analyseKetonePhoto(imageDataUrl) {
  const raw = await callGeminiVision(
    "What is the ketone reading on this meter display?",
    imageDataUrl,
    {
      systemInstruction: SYS,
      responseSchema: KETONE_SCHEMA,
      model: MODELS.ketonePhoto,
      maxOutputTokens: 64,
      temperature: 0.1,
      feature: "ketonePhoto",
    }
  );

  let parsed;
  try { parsed = JSON.parse(raw); } catch { throw new Error("Could not parse meter reading"); }
  if (!parsed || typeof parsed.value !== "number") throw new Error("No reading returned from meter");

  if (parsed.confidence === "high" || parsed.confidence === "medium") {
    const entry = addKetoneReading({ mmol: parsed.value, unit: parsed.unit, source: "photo" });
    return { committed: true, entry };
  }

  return { needsConfirm: true, rawValue: parsed.value, rawUnit: parsed.unit };
}
